export const LOGS_DRAWER_QUERY_NAMESPACE = ["logs-drawer"];
